import { values } from '../_helpers'

const _enum = {
  light: 0,
  mediumMinus: 1,
  medium: 2,
  mediumPlus: 3,
  full: 4
}

const body = { ..._enum, name: 'body', values: values(_enum) }

export {
  body
}
